import LoadingIndicator_module_default from "./LoadingIndicator.module.js";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/LoadingIndicator/index.tsx
const LoadingIndicator = ({ className }) => {
	return /* @__PURE__ */ jsxs("figure", {
		className: cn(LoadingIndicator_module_default.loading, "text-brand-40", className),
		"aria-label": "Loading",
		role: "status",
		children: [
			/* @__PURE__ */ jsx("div", {}),
			/* @__PURE__ */ jsx("div", {}),
			/* @__PURE__ */ jsx("div", {}),
			/* @__PURE__ */ jsx("div", {})
		]
	});
};
//#endregion
export { LoadingIndicator };

//# sourceMappingURL=index.js.map